import { v4 } from "uuid";

export const uuid = (): string => v4();
